(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionType', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'oddQuestionnaireTemplateService','oddSurveyQuestionnaireTemplateService','$state', '$timeout',
        'govNotificationDelay', 'notificationService'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, oddQuestionnaireTemplateService,oddSurveyQuestionnaireTemplateService, $state, $timeout,
                       govNotificationDelay, notificationService) {
        var directiveScope        = _.clone(boxTmplScope);
        directiveScope.addControl = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {
                    
                    $scope.cancel = cancel;
                    $scope.getQuestionAttributeValue = getQuestionAttributeValue;
                    $scope.setQuestionAttributeValue = setQuestionAttributeValue;

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/questionnaireTemplate/questionType/oddQuestionType.[Template].tpl.html';

                    $controller('BoxTmplController', {$scope: $scope});

                    $scope.ctxtCtrl = { isLoading: false };

                    init();
                    initQuestion();


                    // === Actions ===

                    // Reset form
                    $scope.discardChanges = function () {
                        $state.reload();
                    };

                    $scope.createOrUpdate = function() {
                        if ($scope.ctxtCtrl.form.$invalid) {
                            showFormError();
                            return;
                        }
                        $scope.ctxtCtrl.isFormInvalidMsgShow = false;
                        $scope.ctxtCtrl.isLoading = true;

                        if (!$scope.boxModel.ODDQuestionID) {
                            return $scope.createQuestion();
                        }
                        return $scope.updateQuestion();
                    };
                    
                    $scope.createQuestion = function () {
                        var createdQuestion;
                        var urlAfterCreatedQuestion;
                        if ($scope.boxContext.campaign && $scope.boxContext.campaign._isSurvey) {
                            
                            createdQuestion = oddSurveyQuestionnaireTemplateService.createQuestion(
                                $scope.boxContext.questionnaireSection.ODDBusinessUnitID,
                                $scope.boxContext.questionnaireSection.ODDQuestionnaireID,
                                $scope.boxContext.questionnaireSection.ODDSectionID,
                                $scope.boxModel);
                            urlAfterCreatedQuestion = 'odd.surveyCampaignEdit.section.questionEdit';
                        }
                        else {
                            createdQuestion = oddQuestionnaireTemplateService.createQuestion(
                                    $scope.boxContext.questionnaireSection.ODDBusinessUnitID,
                                    $scope.boxContext.questionnaireSection.ODDQuestionnaireID,
                                    $scope.boxContext.questionnaireSection.ODDSectionID,
                                    $scope.boxModel);
                            urlAfterCreatedQuestion= 'odd.questionnaireTemplatesEdit.questionnaire.section.question.edit';

                        }
                        
                        createdQuestion.then(function (createdQuestion) {

                            notificationService.notify('The Question has been created');
                            $scope.ctxtCtrl.form.$setPristine();
                            $state.go(urlAfterCreatedQuestion, {
                                ODDQuestionID: createdQuestion.ODDQuestionID
                            });
                        }).finally(function () {
                            $scope.ctxtCtrl.isLoading = false;
                        });
                    };

                    $scope.updateQuestion = function () {
                        var updatedQuestion;
                        if ($scope.boxContext.campaign && $scope.boxContext.campaign._isSurvey) {
                            updatedQuestion = oddSurveyQuestionnaireTemplateService.updateQuestion(
                                                $scope.boxContext.questionnaireSection.ODDBusinessUnitID,
                                                $scope.boxContext.questionnaireSection.ODDQuestionnaireID,
                                                $scope.boxContext.questionnaireSection.ODDSectionID,
                                                $scope.boxModel);
                            }
                        else {
                            updatedQuestion = oddQuestionnaireTemplateService.updateQuestion(
                                                $scope.boxContext.questionnaireSection.ODDBusinessUnitID,
                                                $scope.boxContext.questionnaireSection.ODDQuestionnaireID,
                                                $scope.boxContext.questionnaireSection.ODDSectionID,
                                                $scope.boxModel);
                        }
                        updatedQuestion.then(function (updatedQuestion) {
                            $scope.boxModel = updatedQuestion;
                            initQuestion();
                            notificationService.notify('Your changes have been saved');
                            $scope.ctxtCtrl.form.$setPristine();

                            return $scope.boxModel;
                        }).finally(function () {
                            $scope.ctxtCtrl.isLoading = false;
                        });
                    };

                    $scope.deleteQuestion = function () {
                        var deletedQuestion;
                        var urlAfterDeletedQuestion;
                        if ($scope.boxContext.campaign && $scope.boxContext.campaign._isSurvey) {
                            deletedQuestion = oddQuestionnaireTemplateService.deleteQuestion(
                                                  $scope.boxContext.questionnaireSection.ODDBusinessUnitID,
                                                  $scope.boxContext.questionnaireSection.ODDQuestionnaireID,
                                                  $scope.boxModel.ODDSectionID,
                                                  $scope.boxModel.ODDQuestionID);
                            urlAfterDeletedQuestion = 'odd.surveyCampaignEdit.section';
                        } else {
                            deletedQuestion = oddQuestionnaireTemplateService.deleteQuestion(
                                                  $scope.boxContext.questionnaireSection.ODDBusinessUnitID,
                                                  $scope.boxContext.questionnaireSection.ODDQuestionnaireID,
                                                  $scope.boxModel.ODDSectionID,
                                                  $scope.boxModel.ODDQuestionID);
                            urlAfterDeletedQuestion = 'odd.questionnaireTemplatesEdit.questionnaire.section';
                        }

                        $scope.ctxtCtrl.isLoading = true;

                        deletedQuestion.then(function () {
                            notificationService.notify('Question has been deleted');

                            $state.go(urlAfterDeletedQuestion, {
                                ODDSectionID: $scope.boxModel.ODDSectionID,
                                ODDQuestionnaireID: $scope.boxContext.questionnaireSection.ODDQuestionnaireID
                            }, { reload: true });

                        }).finally(function () {
                            $scope.ctxtCtrl.isLoading = false;
                        });
                    };

                    $scope.showIsInCampaignErrorMsg = function () {
                        $scope.ctxtCtrl.isInCampaignMsgShow = true;

                        $timeout(function () {
                            $scope.ctxtCtrl.isInCampaignMsgShow = false;
                        }, govNotificationDelay);
                    };

                    function cancel() {
                        $state.go($state.$current.parent.name, { reload: true });
                    }

                    function init() {
                        var withAttachmentDefault = getQuestionAttributeValue($scope.boxModel.ODDQuestionType.ODDQuestionAttributeValues, 'WithAttachment');
                        if (withAttachmentDefault !== null) {
                            withAttachmentDefault = withAttachmentDefault === 'true'
                        }

                        $scope.ctxtCtrl.withAttachmentDefault = withAttachmentDefault;
                    }

                    function initQuestion() {
                        // When creating a question, copy the default attributes
                        if (!$scope.boxModel.ODDQuestionID && $scope.boxModel.ODDQuestionType && $scope.boxModel.ODDQuestionType.ODDQuestionAttributeValues) {
                            $scope.boxModel.ODDQuestionAttributeValues = _.cloneDeep($scope.boxModel.ODDQuestionType.ODDQuestionAttributeValues)
                        }
                    }

                    function showFormError() {
                        $scope.ctxtCtrl.showSubmitError      = true;
                        $scope.ctxtCtrl.isFormInvalidMsgShow = true;

                        $timeout(function () {
                            $scope.ctxtCtrl.isFormInvalidMsgShow = false;
                        }, govNotificationDelay);
                    }

                    function getQuestionAttributeValue(attributeValues, code) {
                        return _.get(_.find(attributeValues, { 'Code': code }), 'ValueText');
                    }

                    function setQuestionAttributeValue(attributeValues, code, value) {
                        _.set(_.find(attributeValues, {'Code': code}), 'ValueText', value);
                    }
                }
            ],
            link: function (scope, elem, attrs, ctrl) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();